export interface PageSEO {
  title: string;
  description: string;
}

export const seoConfig: Record<string, PageSEO> = {
  home: {
    title: "Custom Window Shades & Shutters in Peoria, AZ | Ted's",
    description:
      "Custom shades, shutters, blinds and sun screens with in-home estimates in Peoria, AZ. Ted's Shades & Shutters serves Phoenix, Glendale, Surprise and nearby areas. Call 602-691-4066."
  },
  romanShades: {
    title: "Roman Shades in Peoria, AZ | Custom Window Coverings",
    description:
      "Soft fabric Roman shades measured, made and installed for your home. Ted's Shades & Shutters offers free in-home quotes in Peoria, Phoenix, Glendale, Surprise and nearby areas. Call 602-691-4066."
  },
  cellularShades: {
    title: "Cellular Shades in Peoria, AZ | Energy-Efficient Window Treatments",
    description:
      "Insulating cellular shades that help keep Arizona homes cooler and more private. Free in-home estimates from Ted's Shades & Shutters in Peoria, serving Phoenix, Glendale and Surprise. Call 602-691-4066."
  },
  rollerShades: {
    title: "Roller Shades in Peoria, AZ | Modern Window Shades",
    description:
      "Sleek roller shades with light-filtering and blackout options, custom-fit to your windows. Ted's Shades & Shutters serves Peoria, Phoenix, Glendale, Surprise and surrounding areas. Call 602-691-4066."
  },
  zebraShades: {
    title: "Zebra Shades in Peoria, AZ | Dual-Layer Light Control",
    description:
      "Contemporary zebra shades that switch from sheer to private with a simple adjustment. Get a free in-home quote from Ted's Shades & Shutters in Peoria and the greater Phoenix area. Call 602-691-4066."
  },
  sunScreens: {
    title: "Sun Screens in Peoria, AZ | UV & Heat-Blocking Window Screens",
    description:
      "Exterior sun screens that cut glare, block UV and reduce cooling costs in Arizona homes. Ted's Shades & Shutters installs custom sun screens across Peoria, Phoenix, Glendale and Surprise. Call 602-691-4066."
  },
  plantationWoodShutters: {
    title: "Plantation Shutters in Peoria, AZ | Interior Wood Shutters",
    description:
      "Timeless plantation shutters in real wood for a classic, high-end look. Ted's Shades & Shutters provides design, measuring and installation in Peoria, Phoenix, Glendale and Surprise. Call 602-691-4066."
  },
  woodBlinds: {
    title: "Wood Blinds in Peoria, AZ | Natural Window Blinds",
    description:
      "Warm, natural wood blinds custom-fit to your windows with professional installation. Ted's Shades & Shutters serves homeowners in Peoria, Phoenix, Glendale, Surprise and nearby areas. Call 602-691-4066."
  },
  fauxWoodBlinds: {
    title: "Faux Wood Blinds in Peoria, AZ | Durable Window Blinds",
    description:
      "Moisture-resistant faux wood blinds ideal for kitchens, bathrooms and busy spaces. Free in-home estimates from Ted's Shades & Shutters in Peoria and the Phoenix metro. Call 602-691-4066."
  },
  motorizedShades: {
    title: "Motorized Shades in Peoria, AZ | Smart Window Coverings",
    description:
      "Motorized shades that work with remotes, timers and smart home systems. Ted's Shades & Shutters designs and installs smart window coverings in Peoria, Phoenix, Glendale and Surprise. Call 602-691-4066."
  },
  smartDrapes: {
    title: "Smart Drapes in Peoria, AZ | Automated Drapery Systems",
    description:
      "Automated smart drapes with smooth tracks, remote control and voice assistant options. Ted's Shades & Shutters offers in-home design visits in Peoria and the greater Phoenix area. Call 602-691-4066."
  },
  thankYou: {
    title: "Thank You | Custom Shades & Shutters in Peoria, AZ",
    description:
      "Thank you for contacting Ted's Shades & Shutters. Our team will reach out as soon as possible during business hours to review your window shades or shutters project."
  },
  patioShades: {
    title: "Patio Shades in Peoria, AZ | Outdoor Sun & Heat Protection",
    description:
      "Custom patio shades that block UV rays and reduce heat for comfortable outdoor living. Ted's Shades & Shutters installs weather-resistant patio shades in Peoria, Phoenix, Glendale and Surprise. Call 602-691-4066."
  },
  notFound: {
    title: "Page Not Found | Ted's Shades & Shutters in Peoria, AZ",
    description:
      "The page you requested could not be found. Browse custom shades, shutters, blinds and sun screens from Ted's Shades & Shutters in Peoria, AZ."
  }
};
